'use strict';

angular.module('atex.dam').controller('DamPagePlannerController', ['$scope', '$rootScope', 'AuthenticationService',
  'ContentService', 'Application', '$translate', 'DamConfigurationService', 'DamVersionService',
  '$modal', '$q', '$window', 'DamTemplateService', 'DamNotificationService', 'DamSearchService',
  'DamFoldersService', 'configuration','UIConfigurationService', 'DamService', '$timeout',
  function($scope, $rootScope, AuthenticationService,
         ContentService, Application, $translate, DamConfigurationService, DamVersionService,
         $modal, $q, $window, DamTemplateService, DamNotificationService, DamSearchService,
         DamFoldersService, configuration, UIConfigurationService, DamService, $timeout) {

    $scope.currentUser = 'Unknown User';
    $scope.show = false;
    $scope.size = 0;
    $scope.maxHeight = 'none';
    $scope.anchorPreview = false;

    function resetPanel() {
      $scope.querying = false;
      $scope.loaded = false;
      $scope.onecmsTemplate = undefined;

      $scope.entries = [];
      $scope.publevents = [];
      $scope.id = undefined;
      $scope.showSpinner = false;
      $scope.hits = undefined;
      $scope.currentEntry = undefined;
      $scope.collections = [];
      $scope.parentsIds = [];
      $scope.jobs = [];
      $scope.engagementAspect = undefined;
      $scope.originalContent = undefined;
      $scope.images=[];
    }

    function getTemplate(objComplete) {
      var templateId = objComplete.data.aspects.contentData.data._type;

      templateId += ".dam.planner";
      DamTemplateService.getTemplateById(templateId).then(function(template){
        if (!template) {
          if (console.log) {
            console.log('Template with id ' + templateId + ' has not been found');
          }
        }

        $scope.onecmsTemplate = template;
      }).then(null, function(error) {
        $scope.showSpinner = false;
        console.log('ERROR: getHighLightedEntry:', error);
      });
    }

    function loadPlan(selection) {
      var pages = _.filter(selection, function (entry) {
        return entry;
      });

      pages.sort( ascendingPages );

      var itemsPromises = pages.map(function(entry) {
        return ContentService.getContent({id: entry.id}).then(function(objComplete) {
          atex.dam.AngularUtils.fixUrls(objComplete.data);

          getTemplate( objComplete );

          return objComplete;
        }).then(null, function(error) {
          $scope.showSpinner = false;
          console.log('ERROR: getHighLightedEntry:', error);
          return undefined;
        });
      });

      return $q.all(itemsPromises).then(function(itemsResults) {
        $scope.show = true;
        return _.filter(itemsResults, function (entry) {
          return entry;
        });
      });

    }

    function recalulateSize(size) {
      $scope.size = size;

      if ( $scope.activeWidth > 0 && $scope.activeHeight > 0 && !$scope.settings.wrap ) {
        var thumbSize = size || 200;
        var width = $scope.activeWidth;
        var height = $scope.activeHeight;
        var xscale = thumbSize / width;
        var yscale = thumbSize / height;
        var scale = ( width > height ? xscale : yscale );

        var maxHeight = height * scale;

        $scope.maxHeight = ( maxHeight + 60 ) + 'pt';
      } else {
        $scope.maxHeight = 'none';
      }
    }

    function getPageFromEntry( entry ) {
      if ( typeof entry._data.aspects['atex.print.Page'] !== 'undefined' &&
          typeof entry._data.aspects['atex.print.Page'].data !== 'undefined'  &&
          typeof entry._data.aspects['atex.print.Page'].data.pageNumber !== 'undefined' ) {
        return parseInt( entry._data.aspects['atex.print.Page'].data.pageNumber );
      }

      if ( typeof entry._data.aspects['atex.dam.standard.Publevents'] !== 'undefined' &&
        typeof entry._data.aspects['atex.dam.standard.Publevents'].data !== 'undefined'  &&
        typeof entry._data.aspects['atex.dam.standard.Publevents'].data.publevents !== 'undefined'  &&
        typeof entry._data.aspects['atex.dam.standard.Publevents'].data.publevents.length !== 'undefined'  &&
        typeof entry._data.aspects['atex.dam.standard.Publevents'].data.publevents[0].page !== 'undefined' ) {
        return parseInt( entry._data.aspects['atex.dam.standard.Publevents'].data.publevents[0].page );
      }

      return 0;
    }

    function ascendingPages( entryA, entryB ) {
      return getPageFromEntry( entryA ) - getPageFromEntry( entryB );
    }

    resetPanel();

    $scope.isMobileDevice = function() {
      return DamService.isMobileDevice(768);
    };

    $scope.showmobile = $scope.isMobileDevice();

    var win = angular.element($window);
    win.bind("resize", function(e) {
      $scope.showmobile = $scope.isMobileDevice();
    });


    AuthenticationService.getCurrentUser().then(function(user) {
      $scope.currentUser = user.username.charAt(0).toUpperCase() + user.username.substring(1);
    });

    $scope.$on("dam:pagePlannerToggle", function(event, extraInfo) {
      $scope.show = !$scope.show;
    });

    $scope.showPagePlan = function() {
      $rootScope.$broadcast("dam:pagePlannerToggle");
    };

    $scope.toggleShowFit = function() {
      if ( typeof $scope.settings !== 'undefined' && typeof $scope.module !== 'undefined' ) {
        $scope.settings.showFit = !$scope.settings.showFit;

        if ( $scope.settings.showFit ) {
          $scope.settings.showStatus = false;
        }
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'showFit', $scope.settings.showStatus, $scope.settings.showFit);
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'saveSettings', $scope.activeWidgetId);
      }
    };

    $scope.toggleShowStatus = function() {
      if ( typeof $scope.settings !== 'undefined' && typeof $scope.module !== 'undefined' ) {
        $scope.settings.showStatus = !$scope.settings.showStatus;

        if ( $scope.settings.showStatus ) {
          $scope.settings.showFit = false;
        }
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'showFit', $scope.settings.showStatus, $scope.settings.showFit);
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'saveSettings', $scope.activeWidgetId);
      }
    };

    $scope.toggleShowWrap = function() {
      if ( typeof $scope.settings !== 'undefined' && typeof $scope.module !== 'undefined' ) {
        $scope.settings.wrap = !$scope.settings.wrap;
        recalulateSize( $scope.size );
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'wrap', $scope.settings.wrap);
        $rootScope.$broadcast('activePreview:settings', $scope.module, 'saveSettings', $scope.activeWidgetId);
      }
    };

    $scope.$watch("size", function() {
      if ( typeof $scope.settings !== 'undefined' && typeof $scope.module !== 'undefined' ) {
        if ( $scope.settings.size !== $scope.size ) {
          $scope.settings.size = $scope.size;
          recalulateSize( $scope.size );
          $rootScope.$broadcast('activePreview:settings', $scope.module, 'size', $scope.size);
          $rootScope.$broadcast('activePreview:settings', $scope.module, 'saveSettings', $scope.activeWidgetId);
        }
      }
    });

    $scope.$on('dam:loadPlanView', function(event, selected) {
      $scope.entries = [];
      $scope.onecmsTemplate = undefined;
      $scope.loaded = false;
      $scope.module = undefined;
      $scope.showSpinner = true;

      var pages = _.filter(selected.map(function(entry) {
        if (entry._data.aspects['contentData'].data._type === 'atex.dam.standard.Page') {
          return entry;
        }
      }), function (entry) {
        return entry;
      });

      loadPlan( pages ).then(function( entries ) {
        $scope.entries = entries;
        $scope.show = true;
        $scope.loaded = true;
        $scope.showSpinner = false;
      });
    });

    $scope.$on('activePreview:loaded', function(event, widgetId, module, width, height, settings) {
      if ( typeof $scope.module === 'undefined' ) {
        $scope.module = module;
        $scope.activeWidgetId = widgetId;
        $scope.activeWidth = width;
        $scope.activeHeight = height;
        $scope.settings = settings;

        recalulateSize( settings.size );
      }
    });
}]);


angular.module('atex.dam').directive('damPagePlanner', function() {
  return {
    restrict : 'EA',
    templateUrl : 'views/dam-page-planner.html',

    scope : true,

    controller : 'DamPagePlannerController',

    link : function(scope, element, attrs) {
      if (attrs.id) {
        scope.setPreviewingItemById(attrs.id);
      }
    }

  };
});
